import i18n from "../i18n";

export const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    if (window.location.pathname === '/careers') {
        window.location.reload()
    }
}